import { useState, useRef } from "react";
import { FaBars, FaInfoCircle } from "react-icons/fa";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";

const Menu = ({ position, children }) => {
  const [hidden, setHidden] = useState(false);
  const [msgVisible, setMsgVisible] = useState(null);
  const insertInfoRef = useRef(null);

  const handleSetHidden = () => {
    if (position === "left") {
      insertInfoRef.current.style.top = "3rem";
      setHidden(true);
    } else setHidden(true);
  };

  const handleSetVisible = () => {
    if (position === "left") {
      insertInfoRef.current.style.top = "0";
      setHidden(false);
    } else setHidden(false);
  };

  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  return (
    <aside className={`designer__menu ${position} ${hidden ? "hidden" : ""}`}>
      <div className="designer-menu-wrapper">
        {children}
        <button
          className="designer__menu__hide-button button is-light"
          onClick={handleSetHidden}
          style={labelStyle}
        >
          Hide Menu
        </button>
        {hidden && (
          <button
            className={`designer__menu__show-button ${position} button`}
            style={{
              backgroundColor: variables.menuBgColor,
              color: readableColor(variables.menuBgColor),
            }}
            onClick={handleSetVisible}
          >
            <span className="mr-2">Show Menu</span>
            <FaBars />
          </button>
        )}
      </div>
      {position === "left" && (
        <button
          ref={insertInfoRef}
          className={`reset-button designer__menu__insert-info ${
            msgVisible !== null
              ? msgVisible
                ? "msg-visible"
                : "msg-hidden"
              : ""
          }`}
          onClick={() => setMsgVisible(!msgVisible)}
        >
          <FaInfoCircle style={{ fill: variables.primaryColor }} />
          <span>
            <p>
              This model is displaying the insert which sits inside your drawer.
              Ensure the size is 1/8" smaller than the inner dimensions of your
              drawer.
            </p>
          </span>
        </button>
      )}
    </aside>
  );
};

export default Menu;
